import { removeClassStyleAttrs as e } from "../../common/utils/index.js";
import { CheckableMixin as t, GroupableMixin as n, InputMixin as r, MessagesMixin as i } from "../../common/mixins/input.js";
import { t as a } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import o from "../validation-messages/validation-messages.js";
import { TEXT_SIZE_MODIFIERS as s, TEXT_STRENGTH_MODIFIERS as c } from "../text/text-constants.js";
import l from "../text/text.js";
import { CHECKBOX_INPUT_VALIDATION_CLASSES as u } from "./checkbox-constants.js";
import { createBlock as d, createCommentVNode as f, createElementBlock as p, createElementVNode as m, createTextVNode as h, createVNode as g, mergeProps as _, normalizeClass as v, normalizeStyle as y, openBlock as b, renderSlot as x, resolveComponent as S, toDisplayString as C, toHandlers as w, withCtx as T } from "vue";
//#region components/checkbox/checkbox.vue
var E = {
	compatConfig: { MODE: 3 },
	name: "DtCheckbox",
	components: {
		DtValidationMessages: o,
		DtText: l
	},
	mixins: [
		r,
		t,
		n,
		i
	],
	inheritAttrs: !1,
	props: {
		showLabel: {
			type: Boolean,
			default: !0
		},
		labelSize: {
			type: [String, Number],
			default: null,
			validator: (e) => s.label.includes(String(e))
		},
		labelStrength: {
			type: String,
			default: null,
			validator: (e) => Object.keys(c).includes(e)
		}
	},
	emits: [
		"update:modelValue",
		"focusin",
		"focusout"
	],
	computed: {
		resolvedLabelSize() {
			return this.labelSize ?? 300;
		},
		inputValidationClass() {
			return u[this.internalValidationState];
		},
		checkboxGroupValueChecked() {
			return this.groupContext?.selectedValues?.includes(this.value) ?? !1;
		},
		hasLabelContent() {
			return !!(this.$slots.default || this.label);
		},
		hasLabel() {
			return this.showLabel && this.hasLabelContent;
		},
		hasMessages() {
			return this.formattedMessages.length && this.showMessages;
		},
		inputListeners() {
			return {
				input: () => {},
				focusin: (e) => this.$emit("focusin", e),
				focusout: (e) => this.$emit("focusout", e),
				change: (e) => this.emitValue(e.target)
			};
		}
	},
	watch: { checkboxGroupValueChecked: {
		immediate: !0,
		handler(e) {
			this.hasGroup && (this.internalChecked = e);
		}
	} },
	mounted() {
		this.runValidations();
	},
	methods: {
		removeClassStyleAttrs: e,
		emitValue(e) {
			let { value: t, checked: n } = e;
			this.internalIndeterminate && (n = !1, this.internalIndeterminate = !1, e.checked = !1), this.setGroupValue(t, n), this.$emit("update:modelValue", n);
		},
		runValidations() {
			!this.hasLabelContent && !this.$attrs["aria-label"] && console.warn("[Dialtone] A label is required for accessibility. Provide a label prop and use show-label=\"false\" to hide it visually.");
		}
	}
}, D = { class: "d-checkbox__input" }, O = [
	"checked",
	"name",
	"value",
	"disabled",
	"aria-label",
	".indeterminate"
], k = {
	key: 0,
	class: "d-checkbox__messages",
	"data-qa": "checkbox-description-messages"
};
function A(e, t, n, r, i, a) {
	let o = S("dt-text"), s = S("dt-validation-messages");
	return b(), p("div", {
		class: v(e.$attrs.class),
		style: y(e.$attrs.style)
	}, [m("label", { class: v(["d-checkbox-group", { "d-checkbox-group--disabled": e.internalDisabled }]) }, [m("div", D, [m("input", _({
		type: "checkbox",
		checked: e.internalChecked,
		name: e.internalName,
		value: e.value,
		disabled: e.internalDisabled,
		class: [
			"d-checkbox",
			a.inputValidationClass,
			e.inputClass
		],
		"aria-label": !n.showLabel && e.label ? e.label : void 0
	}, a.removeClassStyleAttrs(e.$attrs), { ".indeterminate": e.internalIndeterminate }, w(a.inputListeners, !0)), null, 48, O)]), a.hasLabel ? (b(), d(o, _({
		key: 0,
		as: "div",
		kind: "label",
		size: a.resolvedLabelSize,
		strength: n.labelStrength ?? "normal",
		tone: e.internalDisabled ? "disabled" : "primary",
		class: [e.labelClass, "d-checkbox__copy d-checkbox__label"]
	}, e.labelChildProps, { "data-qa": "checkbox-label" }), {
		default: T(() => [x(e.$slots, "default", {}, () => [h(C(e.label), 1)])]),
		_: 3
	}, 16, [
		"size",
		"strength",
		"tone",
		"class"
	])) : f("", !0)], 2), e.$slots.description || e.description || a.hasMessages ? (b(), p("div", k, [e.$slots.description || e.description ? (b(), d(o, _({
		key: 0,
		kind: "body",
		size: 200,
		tone: "tertiary",
		as: "div",
		class: ["d-description", e.descriptionClass]
	}, e.descriptionChildProps, { "data-qa": "checkbox-description" }), {
		default: T(() => [x(e.$slots, "description", {}, () => [h(C(e.description), 1)])]),
		_: 3
	}, 16, ["class"])) : f("", !0), g(s, _({
		"validation-messages": e.formattedMessages,
		"show-messages": e.showMessages,
		class: e.messagesClass
	}, e.messagesChildProps, { "data-qa": "dt-checkbox-validation-messages" }), null, 16, [
		"validation-messages",
		"show-messages",
		"class"
	])])) : f("", !0)], 6);
}
var j = /* @__PURE__ */ a(E, [["render", A]]);
//#endregion
export { j as default };

//# sourceMappingURL=checkbox.js.map